import { IconProps } from "../../utils/global-types/global-types";

const FormIcon = ({ className, ...rest }: IconProps) => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={className || "w-[20px] h-[20px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M11.808 4.51H6.433a.925.925 0 0 1-.925-.926V2.175c0-.51.414-.925.925-.925h5.375c.51 0 .925.414.925.925v1.41a.925.925 0 0 1-.925.924M18.02 11.244a1.48 1.48 0 0 0-2.088 0l-.682.686 2.089 2.088.681-.681a1.474 1.474 0 0 0 0-2.093M14.594 12.594 10.95 16.23a.57.57 0 0 0-.143.288l-.276 1.619a.527.527 0 0 0 .607.606l1.619-.275a.53.53 0 0 0 .28-.144l3.644-3.644z"
    ></path>
    <path
      fill="currentColor"
      d="M14.447 2.881h-.778v.703a1.865 1.865 0 0 1-1.863 1.863H6.431A1.864 1.864 0 0 1 4.57 3.584v-.703h-.79c-1.232 0-2.232 1-2.232 2.231V16.52c0 1.231 1 2.231 2.231 2.231h5.91a1.44 1.44 0 0 1-.084-.774l.275-1.614c.049-.286.18-.55.377-.766l3.978-3.973 1.035-1.04a2.4 2.4 0 0 1 1.408-.679V5.12a2.224 2.224 0 0 0-2.23-2.238m-6.301 9.27H5.434a.563.563 0 0 1 0-1.124h2.712a.563.563 0 1 1 0 1.125m3.32-3.192H5.434a.563.563 0 0 1 0-1.125h6.032a.563.563 0 0 1 0 1.125"
    ></path>
  </svg>
  );
};

export default FormIcon;
